"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, type MouseEvent } from "react";
import { createPortal } from "react-dom";
import { twMerge } from "tailwind-merge";
import { useModalStore } from "@/stores/modal-store";
import ModalLayout from "./modal-layout";
export const Modal = () => {
  const $ = _c(34);
  const {
    isOpen,
    modalConfig,
    handleClose
  } = useModalStore();
  let t0;
  if ($[0] !== handleClose || $[1] !== isOpen || $[2] !== modalConfig) {
    t0 = () => {
      const handleEscape = e => {
        if (e.key === "Escape" && modalConfig?.modalOptions?.closeOnEscape) {
          handleClose();
        }
      };
      if (isOpen && modalConfig?.modalOptions?.closeOnEscape) {
        document.addEventListener("keydown", handleEscape);
      }
      if (isOpen && modalConfig?.modalOptions?.preventScroll) {
        document.body.style.overflow = "hidden";
      }
      if (isOpen && modalConfig?.modalOptions?.onOpen) {
        modalConfig.modalOptions.onOpen();
      }
      return () => {
        document.removeEventListener("keydown", handleEscape);
        document.body.style.overflow = "unset";
      };
    };
    $[0] = handleClose;
    $[1] = isOpen;
    $[2] = modalConfig;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const t1 = modalConfig?.modalOptions;
  let t2;
  if ($[4] !== handleClose || $[5] !== isOpen || $[6] !== t1) {
    t2 = [isOpen, t1, handleClose];
    $[4] = handleClose;
    $[5] = isOpen;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t0, t2);
  let t3;
  if ($[8] !== handleClose || $[9] !== modalConfig) {
    t3 = e_0 => {
      if (!modalConfig) {
        return;
      }
      if (e_0.target === e_0.currentTarget && modalConfig.modalOptions?.closeOnOverlayClick) {
        handleClose();
      }
    };
    $[8] = handleClose;
    $[9] = modalConfig;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleOverlayClick = t3;
  if (!isOpen || !modalConfig) {
    return null;
  }
  let t4;
  if ($[11] !== modalConfig.modalOptions?.size) {
    t4 = modalConfig.modalOptions?.size || {};
    $[11] = modalConfig.modalOptions?.size;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const {
    width,
    height,
    minHeight
  } = t4;
  const animation = modalConfig.modalOptions?.animation;
  let t5;
  if ($[13] !== animation) {
    t5 = animation?.enterDuration || animation?.leaveDuration ? {
      "--enter-duration": animation.enterDuration ? `${animation.enterDuration}ms` : undefined,
      "--leave-duration": animation.leaveDuration ? `${animation.leaveDuration}ms` : undefined
    } as React.CSSProperties : undefined;
    $[13] = animation;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const animationStyle = t5;
  const t6 = `fixed inset-0 z-[1050] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 animate-fadeInCustom ${modalConfig.modalOptions?.overlayClassName || ""}`;
  const t7 = modalConfig.modalOptions?.className;
  let t8;
  if ($[15] !== height || $[16] !== minHeight || $[17] !== t7 || $[18] !== width) {
    t8 = twMerge("relative bg-white rounded-lg shadow-xl w-full max-h-[90vh] overflow-y-auto", width, height, minHeight, t7);
    $[15] = height;
    $[16] = minHeight;
    $[17] = t7;
    $[18] = width;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== modalConfig.modalOptions?.stopPropagation) {
    t9 = e_1 => {
      if (modalConfig.modalOptions?.stopPropagation !== false) {
        e_1.stopPropagation();
      }
    };
    $[20] = modalConfig.modalOptions?.stopPropagation;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== handleClose || $[23] !== modalConfig.component) {
    t10 = <ModalLayout onClose={handleClose}>{modalConfig.component}</ModalLayout>;
    $[22] = handleClose;
    $[23] = modalConfig.component;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t8 || $[27] !== t9) {
    t11 = <div className={t8} onClick={t9}>{t10}</div>;
    $[25] = t10;
    $[26] = t8;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== animationStyle || $[30] !== handleOverlayClick || $[31] !== t11 || $[32] !== t6) {
    t12 = createPortal(<div id="modal-root" style={animationStyle} className={t6} onClick={handleOverlayClick}>{t11}</div>, document.body);
    $[29] = animationStyle;
    $[30] = handleOverlayClick;
    $[31] = t11;
    $[32] = t6;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};